export function ga4(name: string, params: Record<string, unknown>): void {
  document.dispatchEvent(new CustomEvent('ga4.track', { detail: { name, params } }));
}
